/* eslint-disable no-console */
import Axios, {AxiosRequestHeaders} from 'axios'

const axios = Axios.create({
 baseURL: process.env.REACT_APP_CMS_API,
})

const token = process.env.REACT_APP_CMS_API_KEY

// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.post['Content-Type'] =
 'application/json'

axios.interceptors.request.use(
 async (config) => {
  const copy = {...config}
  // const token = process.env.REACT_APP_AUTH_KEY

  if (token && copy.headers) {
   ;(
    copy.headers as AxiosRequestHeaders
   ).Authorization = `Bearer ${token}`
  }

  return copy
 },
 async (error) => Promise.reject(error)
)

axios.interceptors.response.use(
 async (response) => {
  if (response.data.error == null) {
   return response
  }
  return Promise.reject(response.data.error)
 },
 async (error) => Promise.reject(error)
)

export default axios
